import { useState } from "react";
import { emptyAssignmentIcon } from "../utils/svg";
import { Modal } from "../utils/Modal";

export const EmptyAssignment = ({ name, message }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleOpen = () => {
    setIsModalOpen(true);
  };

  return (
    <div className="bg-white rounded-lg overflow-hidden">
      <div className="p-6 space-y-4">
        <h2 className="font-bold text-gray-500">Hello {name},</h2>
        <div className="flex flex-col items-center gap-4 text-center">
          <div className="text-center mb-2">{emptyAssignmentIcon()}</div>
          <p className="font-bold">No ongoing assignment</p>
          {/* make font 353535 */}
          <p className="text-sm text-gray-400">{message}</p>
          <p className="text-xs text-gra-400">
            <button onClick={handleOpen} type="button">
              Need Help?
            </button>
            <Modal
              isOpen={isModalOpen}
              header={"Need Help?"}
              message={
                "If you believe an assignment should be visible to you but isn't shown here, please contact the obc@scienslogistics.com ."
              }
              buttonTitle={"Close"}
              buttonAction={() => setIsModalOpen(false)}
            />
          </p>
        </div>
      </div>
    </div>
  );
};
